import React from 'react';
import Web2ArticlePage from '../../../features/off-page/web2/Web2ArticlePage';

interface Props { onBack: () => void; darkMode?: boolean; }

export default function Web2ArticleWrapper({ onBack, darkMode }: Props) {
  const userId = localStorage.getItem('user_id') || '';
  return <Web2ArticlePage onBack={onBack} darkMode={darkMode} userId={userId} />;
}
